import { Container, Row, Col } from "reactstrap";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WorkIcon from "@mui/icons-material/Work";
import SchoolIcon from "@mui/icons-material/School";
import AssignmentIcon from "@mui/icons-material/Assignment";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";



import "./DataSciencePage.css";
import CourseHeroSection from "../../components/common/CourseHero/CourseHeroSection";
import CourseSyllabus from "../../components/common/CourseSyllabus/CourseSyllabus";
import CourseReasons from "../../components/common/CourseReasons/CourseReasons";
import CourseRecommendations from "../../components/common/CourseRecommendations/CourseRecommendations";
import GetInTouch from "../../components/common/Contact/GetInTouch";
import { dataScienceSyllabus } from "../../data/ai_section/dataScienceSyllabus";
import { dataScienceReasons } from "../../data/ai_section/dataScienceReasons";
import { dataScienceRecommendedCourses } from "../../data/ai_section/dataScienceRecommended";
import SEO from "../../components/common/seo/SEO";


const dataScienceFeatures = [
    "Learn from professionals with real-world AI and Machine Learning experience",
    "Understand Data Science, statistics, data manipulation and visualization",
    "Work on practical projects and real-world use cases",
    "Learn Python, SQL, Machine Learning and Generative AI concepts",
    "Build skills for Data Science and related technology roles",
    "Get assignments, projects, study material and expert support",
];


const DataSciencePage = () => {

    return (


        <>
            <SEO
                title="Data Science Course Online | Data Science Training | FeesWorth"
                description="Learn Data Science through practical training in Python, statistics, data analysis, visualization, Machine Learning, Generative AI, and real-world projects with expert guidance."
                keywords="Data Science Course, Data Science Training, Data Science Course Online, Learn Data Science, Data Science Classes, Python Data Science Course, Machine Learning Course, Data Analytics Course, Data Science Certification"
                canonical="https://feesworth.com/data-science-courses-pay-after-learn"
            />
            <main className="datascience-page">

                {/* =====================================================
                HERO
            ====================================================== */}

                <CourseHeroSection
                    badge="DATA SCIENCE TRAINING"
                    title="Data Science"
                    titleHighlight="Course"
                    logo="/DataScience_Logo.webp"
                    logoAlt="Data Science Course"
                    description="Build practical Data Science skills through Python, statistics, data analysis, visualization, Machine Learning, Generative AI, and real-world projects."
                    features={dataScienceFeatures}
                    buttonText="Enroll Now"
                />


                {/* =====================================================
                COURSE OVERVIEW
            ====================================================== */}

                <section className="datascience-overview-section">

                    <Container>

                        <div className="datascience-section-header">

                            <span className="datascience-section-badge">
                                COURSE OVERVIEW
                            </span>

                            <h2>
                                Learn Data Science with{" "}
                                <span>Practical Training</span>
                            </h2>

                        </div>


                        <Row className="align-items-center">

                            <Col lg="7" md="7">

                                <div className="datascience-overview-content">

                                    <p>
                                        The Data Science course is designed by
                                        experts with extensive real-world
                                        experience in artificial intelligence,
                                        machine learning, deep learning, and a
                                        variety of other cutting-edge
                                        technologies.
                                    </p>

                                    <p>
                                        The course focuses on giving you a
                                        thorough understanding of Data Science,
                                        including its applications and usage,
                                        R statistical computing, data
                                        manipulation, data visualisation,
                                        descriptive and inferential statistics,
                                        and much more.
                                    </p>

                                    <p>
                                        Through actual projects and practical
                                        problem-solving, you will gain
                                        experience applying Data Science
                                        concepts to real-world scenarios.
                                    </p>

                                    <p>
                                        The training is designed to help you
                                        build confidence for interviews and
                                        professional Data Science work.
                                    </p>

                                </div>

                            </Col>


                            <Col lg="5" md="5">

                                <div className="datascience-overview-card">

                                    <div className="overview-card-icon">
                                        <SchoolIcon />
                                    </div>

                                    <span>
                                        PRACTICAL LEARNING
                                    </span>

                                    <h3>
                                        Learn by Building
                                    </h3>

                                    <p>
                                        Develop your understanding through
                                        projects, assignments, case studies,
                                        and practical applications.
                                    </p>


                                    <div className="overview-check">

                                        <CheckCircleIcon />

                                        <span>
                                            Real-world projects
                                        </span>

                                    </div>


                                    <div className="overview-check">

                                        <CheckCircleIcon />

                                        <span>
                                            Assignments & study material
                                        </span>

                                    </div>


                                    <div className="overview-check">

                                        <CheckCircleIcon />

                                        <span>
                                            Expert support
                                        </span>

                                    </div>

                                </div>

                            </Col>

                        </Row>

                    </Container>

                </section>


                {/* =====================================================
                COURSE CURRICULUM
            ====================================================== */}

                <section className="datascience-syllabus-section">

                    <CourseSyllabus
                        courseName="Data Science"
                        syllabus={dataScienceSyllabus}
                    />

                </section>


                {/* =====================================================
                HANDS-ON PROJECTS
            ====================================================== */}

                <section className="datascience-project-section">

                    <Container>

                        <div className="datascience-section-header">

                            <span className="datascience-section-badge">
                                PRACTICAL LEARNING
                            </span>

                            <h2>
                                Hands-on{" "}
                                <span>Data Science Projects</span>
                            </h2>

                            <p>
                                Build practical skills by working with
                                use-cases and scenarios based on the
                                learning objectives of the course.
                            </p>

                        </div>


                        <Row className="datascience-project-grid">

                            <Col lg="4" md="6" sm="12">

                                <div className="datascience-project-card">

                                    <div className="project-number">
                                        01
                                    </div>

                                    <div className="project-icon">
                                        <AssignmentIcon />
                                    </div>

                                    <h3>
                                        Data Analysis
                                    </h3>

                                    <p>
                                        Work with data and apply practical
                                        data handling, analysis, and
                                        visualization concepts.
                                    </p>

                                    <div className="project-line"></div>

                                </div>

                            </Col>


                            <Col lg="4" md="6" sm="12">

                                <div className="datascience-project-card">

                                    <div className="project-number">
                                        02
                                    </div>

                                    <div className="project-icon">
                                        <WorkIcon />
                                    </div>

                                    <h3>
                                        Machine Learning
                                    </h3>

                                    <p>
                                        Apply Machine Learning concepts to
                                        practical Data Science use-cases
                                        and datasets.
                                    </p>

                                    <div className="project-line"></div>

                                </div>

                            </Col>


                            <Col lg="4" md="6" sm="12">

                                <div className="datascience-project-card">

                                    <div className="project-number">
                                        03
                                    </div>

                                    <div className="project-icon">
                                        <CheckCircleIcon />
                                    </div>

                                    <h3>
                                        Capstone Project
                                    </h3>

                                    <p>
                                        Prepare, develop, and present a
                                        practical Data Science capstone
                                        project.
                                    </p>

                                    <div className="project-line"></div>

                                </div>

                            </Col>

                        </Row>

                    </Container>

                </section>


                {/* =====================================================
                INDUSTRY STATISTICS
            ====================================================== */}

                <section className="datascience-roles-section">

                    <Container>

                        <div className="datascience-roles-card">

                            <Row className="align-items-center">

                                <Col lg="5" md="5">

                                    <div className="roles-heading">

                                        <span className="datascience-section-badge">
                                            INDUSTRY STATISTICS
                                        </span>

                                        <h2>
                                            Career Paths in{" "}
                                            <span>Data Science</span>
                                        </h2>

                                        <p>
                                            The course content covers skills
                                            relevant to multiple Data Science,
                                            AI, Machine Learning and related
                                            technology roles.
                                        </p>

                                    </div>

                                </Col>


                                <Col lg="7" md="7">

                                    <div className="datascience-role-tags">

                                        <span>
                                            Data Scientist
                                        </span>

                                        <span>
                                            Data Analytics
                                        </span>

                                        <span>
                                            Machine Learning Engineering
                                        </span>

                                        <span>
                                            DI Engineer
                                        </span>

                                        <span>
                                            AI Engineering
                                        </span>

                                        <span>
                                            NLP Engineering
                                        </span>

                                        <span>
                                            Chat Bot Processing Engineering
                                        </span>

                                        <span>
                                            Python Developer
                                        </span>

                                    </div>

                                </Col>

                            </Row>

                        </div>

                    </Container>

                </section>


                {/* =====================================================
                REASONS
            ====================================================== */}

                <CourseReasons
                    courseName="Data Science"
                    badge="WHY LEARN DATA SCIENCE?"
                    description="Explore the practical learning opportunities and career paths covered by the Data Science training."
                    reasons={dataScienceReasons}
                />


                {/* =====================================================
                HIGHLIGHTS
            ====================================================== */}

                <section className="datascience-highlights-section">

                    <Container>

                        <div className="datascience-section-header">

                            <span className="datascience-section-badge">
                                COURSE HIGHLIGHTS
                            </span>

                            <h2>
                                Why Choose Our{" "}
                                <span>Training?</span>
                            </h2>

                        </div>


                        <Row className="datascience-highlight-grid">

                            <Col lg="4" md="6" sm="12">

                                <HighlightCard
                                    icon={<SchoolIcon />}
                                    title="Sessions Led by Professionals"
                                    text="We provide 10 sessions, with each session taking 2 hours to complete the course."
                                />

                            </Col>


                            <Col lg="4" md="6" sm="12">

                                <HighlightCard
                                    icon={<WorkIcon />}
                                    title="Real-Life Case Studies"
                                    text="The course includes examples and case studies based on real-life scenarios."
                                />

                            </Col>


                            <Col lg="4" md="6" sm="12">

                                <HighlightCard
                                    icon={<AssignmentIcon />}
                                    title="Assignments & Projects"
                                    text="Receive assignments, study material, and projects after each session."
                                />

                            </Col>


                            <Col lg="4" md="6" sm="12">

                                <HighlightCard
                                    icon={<SupportAgentIcon />}
                                    title="Exclusive Support"
                                    text="Get access to expert support during the specified support period."
                                />

                            </Col>


                            <Col lg="4" md="6" sm="12">

                                <HighlightCard
                                    icon={<WorkspacePremiumIcon />}
                                    title="Completion Certificate"
                                    text="Receive a Course Completion Certificate after successfully completing the course."
                                />

                            </Col>


                            <Col lg="4" md="6" sm="12">

                                <HighlightCard
                                    icon={<WorkIcon />}
                                    title="Job Assistance"
                                    text="Job support is provided depending on your CTC, experience, and current skills."
                                />

                            </Col>

                        </Row>

                    </Container>

                </section>


                {/* =====================================================
                ONLINE SESSIONS CTA
            ====================================================== */}

                <section className="datascience-enroll-section">

                    <Container>

                        <div className="datascience-enroll-card">

                            <div>

                                <span>
                                    ONLINE SESSIONS
                                </span>

                                <h2>
                                    Ready to start your
                                    Data Science journey?
                                </h2>

                                <p>
                                    Enroll now for a comfortable learning
                                    experience.
                                </p>

                            </div>


                            <a
                                href="#contact"
                                className="datascience-enroll-btn"
                            >
                                ENROLL NOW

                                <ArrowForwardIcon />
                            </a>

                        </div>

                    </Container>

                </section>


                {/* =====================================================
                MORE COURSES
            ====================================================== */}

                <CourseRecommendations
                    courses={dataScienceRecommendedCourses}
                />


                {/* =====================================================
                GET IN TOUCH
            ====================================================== */}

                <section id="contact">

                    <GetInTouch
                        courseName="Data Science"
                        title="GET IN TOUCH"
                        subtitle="Let our executive call you back with complete information"
                    />

                </section>

            </main>
        </>

    );
};


/* =========================================================
   HIGHLIGHT CARD
========================================================= */

const HighlightCard = ({
    icon,
    title,
    text,
}) => {

    return (
        <div className="datascience-highlight-card">

            <div className="highlight-icon">
                {icon}
            </div>

            <div>

                <h3>
                    {title}
                </h3>

                <p>
                    {text}
                </p>

            </div>

        </div>
    );
};


export default DataSciencePage;